type ContentItem = {
  type:
    | 'title'
    | 'logobox'
    | 'quote'
    | 'image'
    | 'paragraph'
    | 'text_img_col'
    | 'intro_paragraph'
    | 'link'
    | 'darkened_list'
    | 'button'
    | 'image_slider'
    | 'list'
    | 'tight_paragraph'
    | 'relaxed_list'
    | 'ordered_list'
    | 'break_line'
}

export function groupBlogElements<T extends ContentItem>(content: T[]): T[][] {
  const groups: T[][] = []
  let curgroup: T[] = []

  for (const obj of content) {
    switch (obj.type) {
      case 'break_line':
      case 'title':
        // make a new group and include this element
        if (curgroup.length) {
          groups.push(curgroup)
          curgroup = []
        }

        curgroup.push(obj)
        break
      case 'logobox':
      case 'image_slider':
        // include this in the current group if the only other element is a title. otherwise put it in a separate group
        // always end the group after this.
        if (curgroup.length === 1 && curgroup[0].type === 'title') {
          curgroup.push(obj)
        } else if (curgroup.length) {
          groups.push(curgroup)
          curgroup = [obj]
        } else {
          curgroup = [obj]
        }

        groups.push(curgroup)
        curgroup = []
        break
      case 'quote':
      case 'image':
      case 'text_img_col':
      case 'darkened_list':
      case 'list':
      case 'relaxed_list':
      case 'ordered_list':
        // break the current group, and put this into its own group. next element should be a new group
        if (curgroup.length) {
          groups.push(curgroup)
          curgroup = []
        }

        groups.push([obj])
        break

      case 'link':
        // allow groups that only consist of links. merge any links into previous group of links
        // (note the no break outside of the if-case)
        if (curgroup.length && curgroup[curgroup.length - 1].type !== 'link') {
          groups.push(curgroup)
          curgroup = [obj]
        }
        break
      case 'paragraph':
      case 'intro_paragraph':
      case 'tight_paragraph':
      case 'button':
        // bundle this in the previous current group
        curgroup.push(obj)
        break
    }
  }

  if (curgroup.length) {
    groups.push(curgroup)
    curgroup = []
  }

  return groups
}
